import { Component, Input } from "@angular/core";
import { PopoverController } from "@ionic/angular";
import { Finishing } from 'src/app/shared-lib/core/settings';

@Component({
  selector: "app-grouped-binding-selector",
  templateUrl: "./grouped-binding-selector.component.html",
  styleUrls: ["./grouped-binding-selector.component.scss"],
  standalone: false
})
export class GroupedBindingSelectorComponent {
  @Input() settings;
  @Input() printProduct;

  constructor(private popoverController: PopoverController) { }

  protected readonly Finishing = Finishing;

  selectOption(grouped) {
    this.popoverController.dismiss({ grouped });
  }

  isGroupedDisabled(): boolean {
    return this.printProduct?.product?.printingGroup?.files?.length === 1;
  }
}
